import { Constants } from "../classic/ts/constants";

export class DateLocale {

  static twelve_hour_time: boolean | undefined;
  static day_first_date: boolean | undefined;

  static formatTwelveHour(): boolean {
    const test_string = new Date().toLocaleString();
    return test_string.match(/AM|PM/) != null;
  }

  static formatDayFirst(): boolean {
    const offset = new Date().getTimezoneOffset();
    const offset_hours = (offset / 60) + 1;
    const day = 7;
    const month = 4;
    const year = 1999;
    const test_date = new Date(Date.UTC(year, (month - 1), day, offset_hours, 0, 0));
    const opts = { year: 'numeric', month: 'numeric', day: 'numeric' };
    const str = test_date.toLocaleDateString(undefined, opts);
    const d_idx = str.indexOf(String(day));
    const m_idx = str.indexOf(String(month));
    const y_idx = str.indexOf(String(year));
    let day_first = true;
    if (d_idx !== undefined && m_idx !== undefined && y_idx !== undefined) {
      if (y_idx > m_idx && m_idx < d_idx) {
        day_first = false;
      }
    }
    return day_first;
  }

  static checkFormatStyle() {
    if (DateLocale.twelve_hour_time === undefined) {
      DateLocale.twelve_hour_time = DateLocale.formatTwelveHour();
    }
    if (DateLocale.day_first_date === undefined) {
      DateLocale.day_first_date = DateLocale.formatDayFirst();
    }
  }

  static formatTime(date: Date): string {
    DateLocale.checkFormatStyle();
    let hour = date.getHours();
    const minute = date.getMinutes();
    var am_pm = hour >= 12 ? Constants.period_pm : Constants.period_am;
    if (DateLocale.twelve_hour_time) {
      hour = hour % 12;
      if (hour == 0) {
        hour = 12;
      }
    }
    let minute_str = String(minute);
    if (minute < 10) {
      minute_str = "0" + minute_str;
    }
    let s = hour + ":" + minute_str;
    if (DateLocale.twelve_hour_time) {
      s += " " + am_pm;
    }
    return s;
  }

  static formatFullDate(date: Date): string {
    DateLocale.checkFormatStyle();
    const month = date.toLocaleString(undefined, { month: "short" });
    const day = date.getDate();
    const year = date.getFullYear();
    let hour = date.getHours();
    const minute = date.getMinutes();
    var am_pm = hour >= 12 ? Constants.period_pm : Constants.period_am;
    if (DateLocale.twelve_hour_time) {
      hour = hour % 12;
      if (hour == 0) {
        hour = 12;
      }
    }
    let minute_str = String(minute);
    if (minute < 10) {
      minute_str = "0" + minute_str;
    }
    let s = "";
    if (DateLocale.day_first_date) {
      s = day + " " + month + " ";
    } else {
      s = month + " " + day + ", ";
    }
    s = s + year + " " + hour + ":" + minute_str;
    if (DateLocale.twelve_hour_time) {
      s += " " + am_pm;
    }
    return s;
  }

  static formatDay(date: Date): string {
    DateLocale.checkFormatStyle();
    const month = date.toLocaleString(undefined, { month: "long" });
    const day = date.getDate();
    const year = date.getFullYear();
    let s = "";
    if (DateLocale.day_first_date) {
      s = day + " " + month + " ";
    } else {
      s = month + " " + day + ", ";
    }
    s = s + year;
    return s;
  }

  static formatRecentDay(date: Date): string {
    const now = new Date();
    const day_ago = new Date(now.getTime() - 86400000);
    const today = function (d: Date): boolean {
      return d.getDate() == now.getDate() &&
        d.getMonth() == now.getMonth() &&
        d.getFullYear() == now.getFullYear();
    }
    const yesterday = function (d: Date): boolean {
      return d.getDate() == day_ago.getDate() &&
        d.getMonth() == day_ago.getMonth() &&
        d.getFullYear() == day_ago.getFullYear();
    }
    if (today(date)) {
      return "Today";
    } else if (yesterday(date)) {
      return "Yesterday";
    } else {
      return date.toLocaleString(undefined, { month: "short", day: "numeric", weekday: "short" });
    }
  }
}